// Sprint 2 — Reorganización de configuración
import { cva, cx } from "styled-system/css";

const skeletonRecipe = cva({
  base: {
    bg: "linear-gradient(90deg, #f1f5f9 0%, #e8eef5 40%, #f1f5f9 80%)",
    backgroundSize: "200% 100%",
    animation: "skeletonShimmer 1.2s ease-in-out infinite",
  },
  variants: {
    variant: {
      line: { h: "3", w: "100%", rounded: "md" },
      circle: { rounded: "full", aspectRatio: "1" },
      card: { h: "24", w: "100%", rounded: "xl" },
    },
  },
  defaultVariants: { variant: "line" },
});

type Props = {
  variant?: "line" | "circle" | "card";
  className?: string;
};

export function Skeleton({ variant = "line", className }: Props) {
  return <div className={cx(skeletonRecipe({ variant }), className)} aria-hidden />;
}
